// Behaviors specific to the courses form:
// 1. Semester segmented picker writes its value to a hidden input.
// 2. Grade type radio cards write their value to a hidden input and toggle
//    the visibility of the "minimum grade" field (only relevant for numeric).
// 3. Switch toggle (allow_edit_grades) flips a hidden boolean field.

document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector("[data-course-form]")
  if (!root) return

  // Semester segmented picker
  const semesterInput = root.querySelector("[data-semester-input]")
  const semesterButtons = root.querySelectorAll("[data-semester-button]")
  const updateSemesterButtons = (active) => {
    semesterButtons.forEach((btn) => {
      const isActive = btn.dataset.semesterButton === String(active)
      btn.setAttribute("aria-pressed", String(isActive))
      btn.classList.toggle("bg-primary-700", isActive)
      btn.classList.toggle("text-white", isActive)
      btn.classList.toggle("text-ink-muted", !isActive)
      btn.classList.toggle("hover:bg-surface", !isActive)
      btn.classList.toggle("hover:text-ink", !isActive)
    })
  }
  semesterButtons.forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault()
      const value = btn.dataset.semesterButton
      if (semesterInput) semesterInput.value = value
      updateSemesterButtons(value)
    })
  })

  // Grade type radio cards
  const gradeTypeInput = root.querySelector("[data-grade-type-input]")
  const gradeTypeCards = root.querySelectorAll("[data-grade-type-card]")
  const minimumGradeWrap = root.querySelector("[data-show-when-numeric]")
  const updateGradeType = (value) => {
    gradeTypeCards.forEach((card) => {
      const isSelected = card.dataset.gradeTypeCard === value
      card.setAttribute("aria-pressed", String(isSelected))
      card.classList.toggle("border-primary-700", isSelected)
      card.classList.toggle("bg-primary-50", isSelected)
      card.classList.toggle("ring-[3px]", isSelected)
      card.classList.toggle("ring-primary-100", isSelected)
      card.classList.toggle("border-border-strong", !isSelected)
      card.classList.toggle("hover:border-primary-600", !isSelected)
      const dot = card.querySelector("[data-radio-dot]")
      if (dot) {
        dot.classList.toggle("border-primary-700", isSelected)
        dot.classList.toggle("border-border-strong", !isSelected)
      }
      const fill = card.querySelector("[data-radio-fill]")
      if (fill) fill.hidden = !isSelected
    })
    if (minimumGradeWrap) minimumGradeWrap.hidden = value !== "numeric"
  }
  gradeTypeCards.forEach((card) => {
    card.addEventListener("click", (event) => {
      event.preventDefault()
      const value = card.dataset.gradeTypeCard
      if (gradeTypeInput) gradeTypeInput.value = value
      updateGradeType(value)
    })
  })

  // Switch toggles (generic)
  root.querySelectorAll("[data-switch-toggle]").forEach((button) => {
    const name = button.dataset.switchToggle
    const input = root.querySelector(`input[data-switch-input='${name}']`)
    if (!input) return
    const knob = button.querySelector("[data-switch-knob]")
    const render = (isOn) => {
      button.setAttribute("aria-pressed", String(isOn))
      button.classList.toggle("bg-primary-700", isOn)
      button.classList.toggle("bg-border-strong", !isOn)
      if (knob) {
        knob.classList.toggle("left-[18px]", isOn)
        knob.classList.toggle("left-0.5", !isOn)
      }
    }
    render(input.value === "1")
    button.addEventListener("click", (event) => {
      event.preventDefault()
      const next = input.value !== "1"
      input.value = next ? "1" : "0"
      render(next)
    })
  })
})
